import { AuthService } from './../core/auth.service';
import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from 'angularfire2/firestore';
import { Observable } from 'rxjs/Observable';
import { take } from 'rxjs/operators';
import { Item } from '../models/item';
import { ActivatedRoute } from '@angular/router';
import { ItemService } from '../services/item.service';

@Component({
  selector: 'app-brand-audit-list',
  templateUrl: './brand-audit-list.component.html',
  styleUrls: ['./brand-audit-list.component.css']
})
export class BrandAuditListComponent implements OnInit {

  surveyCollection: AngularFirestoreCollection<Item>;
  surveys: Observable<Item[]>;
  surveyList: any;
  surveyData: any;
  showSpinner: boolean = true;
  id: number;
  private sub: any;

  readonly path = 'brandAudit';

  calendarDocs: Observable<Item[]>;

  constructor(public afs: AngularFirestore, private itemService : ItemService, private router: Router, private route: ActivatedRoute, private authService: AuthService) {

  }


  getList(): Observable<Item[]>{
    return this.afs.collection<Item>(this.path)
    .snapshotChanges().map(actions => {
      return actions.map(a => {
        const data = a.payload.doc.data() as Item;
        const id = a.payload.doc.id;
         this.showSpinner = false;
        
        return { id, ...data };
      });
    });
  }

  // deleteclient(id) {
  //   var result = confirm("Are you sure you want to delete?");
  //   if (result) {
  //     var deleteDoc = this.afs.collection('brandAudit').doc(id).delete();
  //     // var deleteDoc = this.afs.collection('posts' , ref => ref.where('calendar_id', '==' , id)).doc(id).delete();
  //   }
  // }


  ngOnInit() {
    if (this.authService.loggedInUserRole !== 'Admin') {
      this.router.navigate(['/home'])
    }
    this.showSpinner = true;
    this.calendarDocs = this.getList();
    
  }
}


// WEBPACK FOOTER //
// ./src/app/brand-audit-list/brand-audit-list.component.ts